import { http } from "../base";

export interface LoginCaptchaModel {
    id: string;
    imageBase64: string;
}

class CaptchaService {
    // 挂在 token 下，与登录接口一样无需鉴权
    apiPath = "/api/token/captcha";

    create(): Promise<LoginCaptchaModel> {
        return http.getData(this.apiPath);
    }

    isRequired(): Promise<{ required: boolean }> {
        return http.getData(`${this.apiPath}/required`);
    }
}

export const captchaService = new CaptchaService();
